import type { ImageProps } from 'next/image';

import { emptyPlaceholder } from '~constants/images';
import { MediaTypes, type TMedia } from '~constants/media';
import { FadeInImage } from '~shared/ui/atoms';
import { BlurUpImage } from '~shared/ui/atoms/BlurUpImage';

import { pickImageByType } from './strategies';

export { pickImageByType };

export const ImageRenderer = ({
	width,
	height,
	item = [],
	fallback,
	showPreview = false, //hack for videPreviews
	showLoader = false,
	showLowQualityPreview = false,
	...restProps
}: Omit<ImageProps, 'src'> & {
	item?: TMedia[];
	fallback: string;
	showPreview?: boolean;
	showLoader?: boolean;
	showLowQualityPreview?: boolean;
}) => {
	const { src, loader, type, previewSrc } = pickImageByType(
		item,
		{ width, height },
		fallback,
		showPreview
	);

	return !showLowQualityPreview || type === MediaTypes.videoCf ? (
		<FadeInImage
			src={src ?? emptyPlaceholder}
			style={{
				filter:
					showPreview && type === MediaTypes.videoCf ? 'blur(8px)' : undefined,
				overflow: 'hidden',
			}}
			loader={loader}
			showLoader={showLoader}
			width={width}
			height={height}
			quality={100}
			{...restProps}
		/>
	) : (
		<BlurUpImage
			src={src ?? emptyPlaceholder}
			previewSrc={previewSrc}
			loader={loader}
			width={width}
			height={height}
			quality={100}
			{...restProps}
		/>
	);
};
